import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-[auto_1fr] min-h-full bg-(--color-block-bg,#ffffff)" };
const _hoisted_2 = { class: "min-w-0" };
import { shallowRef } from "vue";
import { moduleRegistry } from "@/router/moduleRegistry";
// Get sidebar component from module registry
// Use shallowRef to avoid making Vue components reactive (performance optimization)
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProfileSettings',
    setup(__props) {
        const SidebarComponent = shallowRef(moduleRegistry.getComponentForSlot("sidebar"));
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (SidebarComponent.value)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(SidebarComponent.value), { key: 0 }))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("main", _hoisted_2, [
                    _createVNode(_component_router_view)
                ])
            ]));
        };
    }
});
